// extracted by mini-css-extract-plugin
export default {"layout":"Delete_layout__GO4-c","buttons":"Delete_buttons__3JRHz","yes":"Delete_yes__kKAUA","no":"Delete_no__6k1ia"};